// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Notify from "@werner/App/Components/Notify";
import { CustomAppState } from "@werner/App/Store/Reducers";
import Tooltip from "@werner/MobiusOverrides/Tooltip/Tooltip";
import Truck2 from "@werner/XDL/Icons/Truck2";
import * as React from "react";
import { connect } from "react-redux";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomAppState) => ({
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    // Xng-Change
    leadTimeMessage: state.xProductDetails.leadTimeMessage,
});

export interface ProductDetailsAvailabilityStyles {
    availability?: ProductAvailabilityStyles;
    // Xng-Change
    leadTimeMessage?: TypographyPresentationProps;
    leadTimeWrapper?: InjectableCss;
}

export const availabilityStyles: ProductDetailsAvailabilityStyles = {};

const styles = availabilityStyles;

const ProductDetailsAvailability = ({ product, configurationCompleted, leadTimeMessage }: Props) => {
    if (!product) {
        return null;
    }

    return (
        <>
            <ProductContextAvailability
                isProductDetailsPage={true}
                configurationCompleted={configurationCompleted}
                extendedStyles={styles.availability}
            />
            {/* Xng-Change WES-1793 */}
            {leadTimeMessage && (
                <StyledWrapper {...styles.leadTimeWrapper}>
                    <Tooltip
                        text={siteMessage("Custom_Lead_Time_Product_TooltipText").toString()}
                        triggerComponent={
                            <Notify
                                {...styles.leadTimeMessage}
                                type="info"
                                data-test-selector="leadTimeMessage"
                                customIconSrc={Truck2}
                                customIconColor="primary"
                            >
                                {leadTimeMessage}
                            </Notify>
                        }
                    />
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsAvailability)),
    definition: {
        displayName: "Availability",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
